import { Box, ITheme, Typography, useTheme } from '@mui/material'
import React from 'react'

interface ISettingsMenuItemProps {
    icon: React.ReactNode;
    title: string;
    selected?: boolean;
}

const SettingsMenuItem: React.FC<ISettingsMenuItemProps> = ({ icon, title, selected }) => {
    const theme = useTheme() as ITheme;

    return (
        <Box display={"flex"} alignItems={"center"} gap={"10px"} padding={"5px"} borderRadius={"8px"} border={selected ? `1px solid ${theme.palette.primary.dark}` : `1px solid transparent`} color={selected ? theme.palette.primary.dark: theme.palette.grey[700]} sx={{ cursor: "pointer"}} bgcolor={selected ? theme.palette.primary.main : undefined}>
            {icon}
            <Typography color={"inherit"} fontWeight={selected ? "bold": "normal"}>{title}</Typography>
        </Box>
    )
}

export default SettingsMenuItem